import * as i0 from '@angular/core';
i0.ComponentFactory;



// WEBPACK FOOTER //
// ./src/app/json-schema-form/schema-label.component.ngfactory.ts